import { lazy } from 'react';

export const AuthLayoutAsync = lazy(() => import('./AuthLayout'));
